import React from "react";

import "./NextButton.css";

export const NextButton = ({disabled, onClick}) => {

    const handleClick = () => {
        if (!disabled) {
            onClick()
        }
    }

    return (
        <div className="next-button-container" onClick={handleClick}>
            <button className="next-button" disabled={disabled}>Next</button>
            <div className="next-button-arrow"/>
        </div>
    );
}
